import React from 'react';
import { Field, useField } from 'formik';
import PropTypes from 'prop-types';
import CustomTypes from 'petco-ui/types';

import IconCheck from '@/shared/assets/icon-check.svg';
import Label from '@/shared/ui/elements/label/Label';
import { getModifiers } from '@/shared/ui/core';
import { InputStyled, InputWrapper, LabelInput } from './Input.styled';

const identity = (value) => value;
const Input = React.forwardRef(({
  $validate,
  label,
  outLabel,
  placeholder,
  modifiers,
  mask = identity,
  markValid = false,
  value,
  onChange,
  ...props
}, ref) => {
  const [, state] = useField(props);
  const valid = !state.error;

  const invalid = $validate && !$validate(value) ? 'danger' : undefined;

  const labelModifiers = ['default', 'required'];

  return (
    <>
      {outLabel && (
        <Label
          content={outLabel}
          modifiers={getModifiers(props, labelModifiers)}
        />
      )}
      <InputWrapper $hasLabel={Boolean(label)}>
        {markValid && valid && <IconCheck />}
        <InputStyled
          {...props}
          id={`id_${props.name}`}
          innerRef={ref}
          placeholder={placeholder}
          modifiers={markValid && valid ? 'success' : modifiers || invalid}
          value={value ?? ''}
          onChange={(event) => {
            if (onChange) {
              onChange({
                target: {
                  name: event.target.name,
                  value: mask(event.target.value ?? ''),
                },
              });
            }
          }}
        />
        <LabelInput>{label}</LabelInput>
      </InputWrapper>
    </>
  );
});

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  outLabel: PropTypes.string,
  modifiers: CustomTypes.oneOrMore(['', 'success', 'danger']),
};

Input.defaultProps = {
  id: '',
  type: '',
  placeholder: '',
  label: '',
  outLabel: '',
  modifiers: '',
};

export default React.forwardRef((props, ref) => <Field as={Input} ref={ref} {...props} />);
